import { ALL_ROUTES } from '@app/router';

/**
 * Builds the URL for the patient-edit page.
 *
 * Resolves between the DS view path
 * (`/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/edit`)
 * and the regular view path
 * (`/:currentAccountUuid/patients/:patientUuid/edit`) based on whether
 * `accountUuid` is provided. The placeholder for `:accountUuid` is
 * replaced unconditionally; on the regular template that replacement
 * is a no-op because the token does not appear in the string.
 *
 * Used by:
 *   - the new patient dashboard's pencil button (legacy adapter)
 *   - `useOrderMetadata`'s "no providers on this account" snackbar
 *     action that links the user to fix the patient.
 *
 * Pure function; no router or hook dependency. Pair with
 * `useNavigate()` at the call site.
 */
const buildEditPatientPath = ({ accountUuid, currentAccountUuid, patientUuid }) => {
  const template = accountUuid
    ? ALL_ROUTES.patient.editDS.path
    : ALL_ROUTES.patient.edit.path;
  return template
    .replace(':currentAccountUuid', currentAccountUuid)
    .replace(':accountUuid', accountUuid || '')
    .replace(':patientUuid', patientUuid);
};

export default buildEditPatientPath;
